(function () {
function $e1e30974ea5219c9$export$2e2bcd8739ae039() {
    var collectionSlides = document.querySelectorAll('.slider__slide');
    var slides = Array.from(collectionSlides);
    var dotContainer = document.querySelector('.slider__dots');
    var currentSlide = 0;
    var cloneFirsSlide = collectionSlides[0].cloneNode(true);
    slides.push(cloneFirsSlide);
    dotContainer.insertAdjacentElement('beforebegin', cloneFirsSlide);
    var createDots = function() {
        slides.forEach(function(_, i) {
            if (i <= 3) dotContainer.insertAdjacentHTML('beforeend', "<button class='slider__button' data-slide='".concat(i, "'></button>"));
        });
    };
    var activateDot = function(numberSlide) {
        var collectonDots = document.querySelectorAll('.slider__button');
        collectonDots.forEach(function(dot) {
            dot.classList.remove('slider__button--active');
        });
        document.querySelector(".slider__button[data-slide='".concat(numberSlide, "']")).classList.add('slider__button--active');
    };
    var goToSlide = function(numberSlide) {
        slides.forEach(function(s, i) {
            s.style.transform = "translate(".concat(100 * (i - numberSlide), "%)");
        });
    };
    slides.forEach(function(s, i) {
        s.style.transform = "translate(".concat(100 * i, "%)");
    });
    dotContainer.addEventListener('click', function(e) {
        var slide = e.target.dataset.slide;
        if (!slide) return;
        activateDot(slide);
        goToSlide(slide);
    });
    setInterval(function() {
        goToSlide(currentSlide);
        activateDot(currentSlide);
        currentSlide = (currentSlide + 1) % 4;
    }, 1500);
    var init = function() {
        createDots();
        activateDot(0);
        goToSlide(0);
    };
    init();
}


(0, $e1e30974ea5219c9$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=Museum.11cce9ed.js.map
